module.exports = __webpack_public_path__ + "img/17.952a462b.jpg";